
import { Injectable } from '@angular/core';
import { Claim } from '../models/Claim';
import { BehaviorSubject } from 'rxjs';
import { ClaimDataService } from './claim-data.service';
import { ClaimSearchResultItem } from '../models/ClaimSearchResultItem';
import { SearchClaimsService } from './search-claims.service';
import { SearchClaimsCriteria } from '../models/SearchClaimsCriteria';
import { TripleStateBoolean } from 'src/app/shared/model/TripleStateBoolean';

@Injectable({
  providedIn: 'root'
})
export class CurrentClaimDataService {

  constructor(private claimDataService: ClaimDataService,
    private searchClaimsService: SearchClaimsService
  ){
    
  }

  currentClaim:Claim = null;
  _currentClaim = new BehaviorSubject<Claim>(null);
  readonly currentClaim$ = this._currentClaim.asObservable();


  currentClaimSearchResultItem:ClaimSearchResultItem = null;
  _currentClaimSearchResultItem = new BehaviorSubject<ClaimSearchResultItem>(null);
  readonly currentClaimSearchResultItem$ = this._currentClaimSearchResultItem.asObservable();

  _isCurrentClaimSearchResultItemLoading = new BehaviorSubject<boolean>(false);
  readonly isCurrentClaimSearchResultItemLoading$ = this._isCurrentClaimSearchResultItemLoading.asObservable();



  public SetCurrentClaim(claim:Claim){
    this.currentClaim = claim;
    if(claim?.systemIdentifier != this.currentClaimSearchResultItem?.systemIdentifier){
      this.RefreshCurrentClaimSearchResultItem(claim.systemIdentifier);
    }
    this._currentClaim.next(claim);
  }

  public RefreshCurrentClaim(claimIdentifier:string){

    this.claimDataService.getClaimData(claimIdentifier).subscribe(claim => {
      this.currentClaim = claim;
      this._currentClaim.next(claim);
    });
  }

  public SetCurrentSearchClaimResultItem(claimSearchResultItem:ClaimSearchResultItem){
    this.currentClaimSearchResultItem = claimSearchResultItem;
    this._currentClaimSearchResultItem.next(claimSearchResultItem);
  }

  public RefreshCurrentClaimSearchResultItem(claimIdentifier:string){

    this._isCurrentClaimSearchResultItemLoading.next(true);

    const criteria : SearchClaimsCriteria = {
      includeCancelled: true,
      includeClosed: true,
      includeArchived:true,
      includeSuspended: true,
      includeTotalLoss: true,
      includeClosedWithoutExecution: true,
      includeScanWithoutRepair: true,
      includeExpectingForDecision: true,
      includeFreeServices: true,
      glassClaimsOnly: false,
      isInspectionWithRepairOnly: false,
      repairPriorityClaimsOnly: false,
      isMassiveClaimHandlingState: TripleStateBoolean.All,
      includeClaimPaymentDeclarationSummary: true,
      pageNumber: 1,
      rowsPerPage: 1,
       systemIdentifier: claimIdentifier
    };

    this.searchClaimsService.searchClaims(criteria).subscribe(foundClaims => {
      const foundItem = foundClaims.claimsData[0];
      this.currentClaimSearchResultItem = foundItem;
      this._currentClaimSearchResultItem.next(foundItem);
      this._isCurrentClaimSearchResultItemLoading.next(false);
    });
  }
   
}
